module.exports = __webpack_public_path__ + "static/media/right-arrow.d01edd19.png";